import { Outlet } from 'react-router-dom';

import ScreenWrapper from '@/components/ui/ScreenWrapper';
import ErrorBoundary from '@/components/ErrorBoundary';
import NeuerStandWaechter from '@/components/NeuerStandWaechter';

const RootView = () => {
  return (
    <ErrorBoundary>
      <ScreenWrapper>
        <NeuerStandWaechter>
          <Outlet />
        </NeuerStandWaechter>
      </ScreenWrapper>
    </ErrorBoundary>
  );
};

export default RootView;
